// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal.css */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.modal-overlay.show {
  opacity: 1;
}

.modal-content {
  background: white;
  width: 100%;
  height: 100%;
  padding: 20px;
  border-radius: 0;
  position: relative;
  overflow: hidden;
  opacity: 0;
  transition: opacity 0.3s ease;
  color: black; /* Ensure text color is visible */
  flex-direction: column;
  justify-content: space-between;
}

.modal-content.show {
  opacity: 1;
}

.modal-close {
  position: absolute;
  top: 10px;
  right: 0px;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 3;
}

.close-icon-image {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.modal-image {
  width: 100%;
  height: 100%;
  opacity: 1; /* Set the opacity to make the image opaque */
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.modal-avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  margin-bottom: 20px;
  position: relative;
  z-index: 2;
  align-self: flex-start;
  margin-right: 100%;
}

.modal-content p {
  margin: 0;
  color: black; /* Ensure text color is visible */
  position: relative;
  z-index: 2;
}

.modal-translate {
  position: absolute;
  top: 10px;
  right: 115px; /* Adjust as needed to position next to the close button */
  background: none;
  border: none;
  cursor: pointer;
  z-index: 3;
  display: none;
}

.translate-icon {
  width: 50px;
  height: 50px;
}

.modal-content-text {
  flex: 1 1; /* Allow the text content to take the remaining space */
  position: relative;
  z-index: 2;
  text-align: left; /* Align text to the left */
}


.modal-content-text p {
  margin: 0;
  color: black; /* Ensure text color is visible */
  text-align: left; /* Align paragraph text to the left */
}

.modal-content-bottom {
  margin-top: auto;
  padding-top: 20px;
}

.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-text {
  visibility: hidden;
  width: 60px;
  background-color: black;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: 80%;
  left: 10%;
  margin-left: -30px;
  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip-container:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

.modal-video {
  margin-top: 20px;
  text-align: center;
}

.modal-video video {

  border-radius: 8px;
  

}
.video-overlay {
  z-index: 3;
position: absolute;
top : 75%;
left: 1%;
width: 400px!important;
height: 200px!important;
}

/*
.below-modal {
  margin-top: 100%;
  text-align: center;
  background-color: #f0f0f0;
  padding: 10px;
  border-radius: 8px;
  position: relative;
}*/
.below-modal {
  width: 100%; /* Ensure it takes the full width of the screen */
  padding: 20px; /* Optional: Add some padding for better spacing */
  box-sizing: border-box; /* Include padding and border in the element's total width and height */
  background-color: #f8f9fa; /* Optional: Add a background color */
  margin-top: 100%;
  
  position: relative;
}

.below-modal p {
  margin: 0; /* Remove default margin */
}

.modal-next {
    margin-top: 20px;
    
    padding: 10px 20px;
    background-color: #007bff;
    color: white;
    border: none;
    
    border-radius: 4px;
    position: absolute;
    z-index: 3;
    cursor: pointer;
    right: 10vh;
    top: 94vh;
}

.modal-prev {
  margin-top: 20px;
    
  padding: 10px 20px;
  background-color: #007bff;
  color: white;
  border: none;
  
  border-radius: 4px;
  position: absolute;
  z-index: 3;
  cursor: pointer;
  right: 20vh;
  top: 94vh;
}

.modal-next:hover {
  background-color: #0056b3;
}



.modal-scroll {
  margin-top: 20px;
    
  padding: 10px 20px;
  color: white;
  border: none;
  
  background-color: #007bff;
  border-radius: 4px;
  position: absolute;
  z-index: 3;
  cursor: pointer;
  right: 35vh;
  top: 94vh;
}
.modal-scroll-img {
  width: 20px;
  height: 18px;
  text-align: center;
}

/* Modal.css */
.popup-overlay {
  position: fixed;
  top: 10vh;
  left: 70vh;
  /* width: 50%; */
  height: 61%;
  width: -webkit-fill-available;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  z-index: 4;
}

.popup-content {
 
  border-radius: 8px;
width: 100%;
}

.close-popup-button {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
}

.open-popup-button {
  margin-top: 20px;
    
  padding: 10px 20px;
  color: white;
  border: none;
  
  background-color: #007bff;
  border-radius: 4px;
  position: absolute;
  z-index: 3;
  cursor: pointer;
  right: 40vh;
  top: 94vh;
}

.open-popup-button:hover {
  background-color: #0056b3;
}


.modal-copilot {
  position: absolute;
  top: 10px;
  right: 90px; /* Adjust as needed to position next to the close button */
  background: none;
  border: none;
  cursor: pointer;
  z-index: 3;
}

.quizlet-icon {
  width: 50px;
  height: 50px;
}

.chat-modal {
  position: fixed;
  bottom: 50px; 
  right: 0;
  width: 400px;
  height: 80%;
  background-color: white;
  border-radius: 10px 10px 0 0;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.chat-modal iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.close-button {
  position: absolute;
  top: -5px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: white;
  z-index: 1001;
}

.close-button:hover {
  border: 1px solid white;
}`, "",{"version":3,"sources":["webpack://./src/Modal.css"],"names":[],"mappings":"AAAA,cAAc;AACd;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,6BAA6B;EAC7B,YAAY,EAAE,iCAAiC;EAC/C,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU,EAAE,6CAA6C;EACzD,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,YAAY,EAAE,iCAAiC;EAC/C,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY,EAAE,0DAA0D;EACxE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;EACV,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO,EAAE,uDAAuD;EAChE,kBAAkB;EAClB,UAAU;EACV,gBAAgB,EAAE,2BAA2B;AAC/C;;;AAGA;EACE,SAAS;EACT,YAAY,EAAE,iCAAiC;EAC/C,gBAAgB,EAAE,qCAAqC;AACzD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;;;AAGpB;AACA;EACE,UAAU;AACZ,kBAAkB;AAClB,SAAS;AACT,QAAQ;AACR,sBAAsB;AACtB,uBAAuB;AACvB;;AAEA;;;;;;;;EAQE;AACF;EACE,WAAW,EAAE,iDAAiD;EAC9D,aAAa,EAAE,kDAAkD;EACjE,sBAAsB,EAAE,uEAAuE;EAC/F,yBAAyB,EAAE,qCAAqC;EAChE,gBAAgB;;EAEhB,kBAAkB;AACpB;;AAEA;EACE,SAAS,EAAE,0BAA0B;AACvC;;AAEA;IACI,gBAAgB;;IAEhB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;;IAEZ,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,WAAW;IACX,SAAS;AACb;;AAEA;EACE,gBAAgB;;EAEhB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,YAAY;;EAEZ,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;;;AAIA;EACE,gBAAgB;;EAEhB,kBAAkB;EAClB,YAAY;EACZ,YAAY;;EAEZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,WAAW;EACX,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,6BAA6B;EAC7B,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;AACpB,WAAW;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;;EAEhB,kBAAkB;EAClB,YAAY;EACZ,YAAY;;EAEZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW,EAAE,0DAA0D;EACvE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,4BAA4B;EAC5B,wCAAwC;EACxC,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["/* Modal.css */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.modal-overlay.show {\n  opacity: 1;\n}\n\n.modal-content {\n  background: white;\n  width: 100%;\n  height: 100%;\n  padding: 20px;\n  border-radius: 0;\n  position: relative;\n  overflow: hidden;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  color: black; /* Ensure text color is visible */\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.modal-content.show {\n  opacity: 1;\n}\n\n.modal-close {\n  position: absolute;\n  top: 10px;\n  right: 0px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  z-index: 3;\n}\n\n.close-icon-image {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n}\n\n.modal-image {\n  width: 100%;\n  height: 100%;\n  opacity: 1; /* Set the opacity to make the image opaque */\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n}\n\n.modal-avatar {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n  margin-bottom: 20px;\n  position: relative;\n  z-index: 2;\n  align-self: flex-start;\n  margin-right: 100%;\n}\n\n.modal-content p {\n  margin: 0;\n  color: black; /* Ensure text color is visible */\n  position: relative;\n  z-index: 2;\n}\n\n.modal-translate {\n  position: absolute;\n  top: 10px;\n  right: 115px; /* Adjust as needed to position next to the close button */\n  background: none;\n  border: none;\n  cursor: pointer;\n  z-index: 3;\n  display: none;\n}\n\n.translate-icon {\n  width: 50px;\n  height: 50px;\n}\n\n.modal-content-text {\n  flex: 1; /* Allow the text content to take the remaining space */\n  position: relative;\n  z-index: 2;\n  text-align: left; /* Align text to the left */\n}\n\n\n.modal-content-text p {\n  margin: 0;\n  color: black; /* Ensure text color is visible */\n  text-align: left; /* Align paragraph text to the left */\n}\n\n.modal-content-bottom {\n  margin-top: auto;\n  padding-top: 20px;\n}\n\n.tooltip-container {\n  position: relative;\n  display: inline-block;\n}\n\n.tooltip-text {\n  visibility: hidden;\n  width: 60px;\n  background-color: black;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  position: absolute;\n  z-index: 1;\n  top: 80%;\n  left: 10%;\n  margin-left: -30px;\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n\n.tooltip-container:hover .tooltip-text {\n  visibility: visible;\n  opacity: 1;\n}\n\n.modal-video {\n  margin-top: 20px;\n  text-align: center;\n}\n\n.modal-video video {\n\n  border-radius: 8px;\n  \n\n}\n.video-overlay {\n  z-index: 3;\nposition: absolute;\ntop : 75%;\nleft: 1%;\nwidth: 400px!important;\nheight: 200px!important;\n}\n\n/*\n.below-modal {\n  margin-top: 100%;\n  text-align: center;\n  background-color: #f0f0f0;\n  padding: 10px;\n  border-radius: 8px;\n  position: relative;\n}*/\n.below-modal {\n  width: 100%; /* Ensure it takes the full width of the screen */\n  padding: 20px; /* Optional: Add some padding for better spacing */\n  box-sizing: border-box; /* Include padding and border in the element's total width and height */\n  background-color: #f8f9fa; /* Optional: Add a background color */\n  margin-top: 100%;\n  \n  position: relative;\n}\n\n.below-modal p {\n  margin: 0; /* Remove default margin */\n}\n\n.modal-next {\n    margin-top: 20px;\n    \n    padding: 10px 20px;\n    background-color: #007bff;\n    color: white;\n    border: none;\n    \n    border-radius: 4px;\n    position: absolute;\n    z-index: 3;\n    cursor: pointer;\n    right: 10vh;\n    top: 94vh;\n}\n\n.modal-prev {\n  margin-top: 20px;\n    \n  padding: 10px 20px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  \n  border-radius: 4px;\n  position: absolute;\n  z-index: 3;\n  cursor: pointer;\n  right: 20vh;\n  top: 94vh;\n}\n\n.modal-next:hover {\n  background-color: #0056b3;\n}\n\n\n\n.modal-scroll {\n  margin-top: 20px;\n    \n  padding: 10px 20px;\n  color: white;\n  border: none;\n  \n  background-color: #007bff;\n  border-radius: 4px;\n  position: absolute;\n  z-index: 3;\n  cursor: pointer;\n  right: 35vh;\n  top: 94vh;\n}\n.modal-scroll-img {\n  width: 20px;\n  height: 18px;\n  text-align: center;\n}\n\n/* Modal.css */\n.popup-overlay {\n  position: fixed;\n  top: 10vh;\n  left: 70vh;\n  /* width: 50%; */\n  height: 61%;\n  width: -webkit-fill-available;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  z-index: 4;\n}\n\n.popup-content {\n \n  border-radius: 8px;\nwidth: 100%;\n}\n\n.close-popup-button {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: none;\n  border: none;\n  font-size: 20px;\n  cursor: pointer;\n}\n\n.open-popup-button {\n  margin-top: 20px;\n    \n  padding: 10px 20px;\n  color: white;\n  border: none;\n  \n  background-color: #007bff;\n  border-radius: 4px;\n  position: absolute;\n  z-index: 3;\n  cursor: pointer;\n  right: 40vh;\n  top: 94vh;\n}\n\n.open-popup-button:hover {\n  background-color: #0056b3;\n}\n\n\n.modal-copilot {\n  position: absolute;\n  top: 10px;\n  right: 90px; /* Adjust as needed to position next to the close button */\n  background: none;\n  border: none;\n  cursor: pointer;\n  z-index: 3;\n}\n\n.quizlet-icon {\n  width: 50px;\n  height: 50px;\n}\n\n.chat-modal {\n  position: fixed;\n  bottom: 50px; \n  right: 0;\n  width: 400px;\n  height: 80%;\n  background-color: white;\n  border-radius: 10px 10px 0 0;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n  z-index: 1000;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.chat-modal iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n}\n\n.close-button {\n  position: absolute;\n  top: -5px;\n  right: 10px;\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: white;\n  z-index: 1001;\n}\n\n.close-button:hover {\n  border: 1px solid white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
